import React, { useState } from "react";
import DirectorModal from "./DirectorModal";
import "./Director.css";
import Onyia from "../../assets/Onyia.jpg";
import Arinze from "../../assets/Arinze.jpg";
import Kenneth from "../../assets/Kenneth.jpg";
import Mary from "../../assets/Mary.jpg";
import Ruth from "../../assets/Ruth.jpg";
import Quadri from "../../assets/Quadri.jpg";
import Gerald from "../../assets/Gerald.jpg";
import Omo from "../../assets/Omo.jpg";

// Example data for directors; each director should have a name, image, and achievements
const directors = [
  {
    id: 1,
    name: "Gerald Nnamokwor Esq.",
    position: "Group Chairman",
    image: Gerald,
    achievements: `Mr. Nnamokwor is a seasoned international corporate commercial lawyer. He graduated from
    the very prestigious University of Nigeria Nsukka with Second Class Honors (Upper Division)
    
    in 2017 after which he proceeded to the Nigerian Law School, Lagos and was called to the
    Nigerian Bar in 2018.
    After his call to the Nigerian Bar, he joined Kenna Partners, a leading commercial law firm in
    Victoria Island Lagos State. While in Kenna Partners, Gerald worked with a team of other
    lawyers in the firm to defend, advise and represent many multi-national companies in Nigeria
    including ExxonMobil, Zenith Bank PLC, MTN Nigeria Communications and other top
    companies in Nigeria as well as government institutions and agencies including the Central
    Bank of Nigeria and other top government agencies in Nigeria. In August 2020, Gerald
    founded Grand Attorneys, a top commercial law firm with an office in Lekki Phase 1, Lagos
    State, focused on rendering tier one legal services in Nigeria. In September 2022, He
    proceeded to England, United Kingdom, where he obtained a master’s degree in international
    commercial law at the very prestigious University of Bradford in December 2023. Gerald also
    founded Luxor Gate Health Care Services Limited aimed at rendering care services to people
    with mental health challenges such as bipolar disorder, schizophrenia, dementia, autism,
    learning disability, Etc., in England, United Kingdom. Gerald is also the founder of Geedon
    Farms, an agricultural company focused on crop production in Eastern Nigeria. Gerald equally
    founded Luxor Gate Limited; a real estate company based in Lagos State Nigeria.
    Gerald has also written several articles some of which have been published including
    “Resource Control by States in Nigeria: Issues and Challenges Under the Nigerian
    Constitution”, published in Unilag Law Review, Vol. 3 No.1, August 2019. He also wrote
    ‘Negligent Misstatement of facts leading to economic loss: the damages thereof’, also
    published in Unilag Law Review in 2020.
    His areas of practice include but are not limited to Real Estate, Oil and Gas, Banking and
    Insurance, Corporate Governance, Project Finance, Election Petition, Medical Law,
    Telecommunication, Etc.
    It was the wide experiences Gerald has gathered over the years and the passion to make life
    easy for average Nigerians that motivated him into founding Geega Resources with a view to
    reducing the prices of commodities in Nigeria to the lowest minimum through mass production
    of food and other commodities.`,
  },
  {
    id: 2,
    name: "Professor Vincent Onyia",
    position: "Director of crop production and research",
    image: Onyia,
    achievements: `Vincent Onyia is a Professor of Plant Breeding and Genetics at the University of Nigeria,
Nsukka. He is a versatile scholar with numerous publications in both local and international
journals and has held so many positions both in private and public institutions. He is also a
reviewer of many local and international journals and has supervised so many students both at
the undergraduate and postgraduate levels. Prof. Onyia holds a Doctor of Philosophy (Ph.D) in
Crop Science, University of Nigeria, Nsukka, Certificate in Plant Genetic Conservation,
Wagenninggen International, the Netherlands and Post Graduate Diploma in Education

(PGDE) Usman Danfodio University, Sokoto Nigeria. He was also a consultant to FADAMA II
project of the World Bank in Nigeria.`,
  },
  {
    id: 3,
    name: "Keneth Eze Esq.",
    position: "Managing Director",
    image: Kenneth,
    achievements: `Mr. Kenneth Eze is a reputable legal practitioner with multiple years of experience in private
law practice. He obtained a bachelor’s degree in law (LL. B) from the very prestigious
University of Nigeria Nsukka in the year 2017 with 2nd Class Honours (Upper Division). He
subsequently proceeded to the Nigerian Law School, Lagos Campus in the same year and

upon successful completion of the programme, he was called to Nigerian Bar in November
2018. Mr. Kenneth Eze began his professional journey as a lawyer at M. M. KALU &amp; CO, a
top commercial law firm in Rivers State where he completed his National Youths Service and
was retained by the firm due to his excellence in service delivery. Kenneth had been in private
legal practice since early 2019. Due to his passion for self-development and to explore other
opportunities, Kenneth took a job as an Associate at Rockville Associates located in Port
Harcourt, Rivers State where he worked with other team of lawyers to render efficient and
effective services to individuals, governments and to national and multinational companies
across the federation. Kenneth is a member of the Nigerian Bar Association (NBA), Port
Harcourt Branch. He is also a Partner at Princeken Partners &amp; Solicitors, a commercial law
firm headquartered in Lagos State, Nigeria. Kenneth has special interest in Banking law
Practice and Commerce, as well as real estate. He has joined Geega Resources to contribute
to the growth and development of the organization.`,
  },
  // Add more directors as needed
  {
    id: 4,
    name: "Mr. Quadri Alade",
    position: "Deputy Managing Director",
    image: Quadri,
    achievements: `Quadri graduated from the Federal Polytechnic Ede, Osun State in 2013 with a National
Diploma in Civil Engineering. He thereafter proceeded to the great University of Kwara State
and graduated in 2017 with a Bachelor of Science in Architecture. Mr. Alade again went ahead
in his academic journey and in 2023, he graduated from the University of Kwara State with a
master’s degree in architecture.

Mr. Alede began his professional career at AARAJI Nig Ltd as a project manager and architect
in 2018 where he designed and supervised the construction of many houses and apartments
for the company. In 2019, Mr. Alede again became a site supervisor/ architect at Herbenger
PLC where he designed, supervised and managed the construction of various commercial
buildings for the company. He further worked for Nigerian Bottling Company (NBC) where he
designed and supervised the construction of the company’s new factory and warehouse in
2022 at Idu Industrial Area, Jabi Road, Abuja.

As a result of Mr. Quadri Alade’s excellence displayed at the various places where he worked,
he was again hired by the highly reputable Westlink Iconic Estate, Ibadan, Oyo State where he
worked as an architect. He designed and supervised the construction of the estate’s various

residential and commercial buildings. Mr. Alede is an excellent worker, he has offered to
contribute his quota in assisting Geega Resources in actualizing its objectives in empowering
the great Southern Nigerian youths.`,
  },
  {
    id: 5,
    name: "Arinze Okoye Esq.",
    position: "Director of Legal Services",
    image: Arinze,
    achievements: `Arinze Okoye is a dedicated and versatile legal professional with multiple years of experience
across diverse sectors in the legal industry. His career has spanned high-stakes legal
advisory, compliance, and corporate governance, all of which have equipped him with a robust
understanding of both the legal and operational intricacies that drive business success. To
complement his legal expertise, he has proactively developed skills in data analysis and
project management, recognizing the critical role these disciplines play in today’s business
environment. His data-driven approach enables him to provide deeper insights and innovative
solutions, while his project management knowledge ensures efficient, streamlined processes
in all legal projects he undertakes. Currently, he is further expanding his knowledge and
credentials through the ICSAN (Institute of Chartered Secretaries and Administrators of
Nigeria) program, equipping himself with specialized expertise in corporate governance,
secretarial practice, and regulatory compliance. He has joined Geega Resources to contribute
to the growth and development of the organization.`,
  },
  {
    id: 6,
    name: "Mr. Omotayo Alade",
    position: "Director of Finance",
    image: Omo,
    achievements: `Omotayo graduated in 2006 from the very prestigious Federal Polytechnic Ede, Osun State
with a Higher National Diploma in banking and finance. After completing the compulsory
National Youth Service Corps in 2008 Mr. Alade joined the First Bank of Nigeria, Osogbo
Branch as Bulk Teller. While assuming this role, Mr. Alede handled payments and receiving of
cheques, receiving and posting of dividends, receiving and payment of bulk cash, interbank
money transfers, posting of salaries, Etc.
As a result of the overwhelming level of excellence displayed by Mr. Alade, he was promoted
to the level of Head of Customer Services for the branch in 2011. While holding this position,
Mr. Alade handled sensitive roles such as opening new bank accounts for new customers,
closing accounts at customer’s requests, solving customer’s pressing needs, setting up of
customer’s loans.
In 2013, Mr. Alade moved to the Federal Capital Territory Abuja where he worked as Security
Manager/ Client Relationship Manager Kyas Nigeria Ltd. While working for the company, he
prompted escalation and reporting of incidents to clients, he also coordinated security activities
and developed budgets for security operations. Mr Alede worked in Kyas Nigeria Ltd till 2015
when he moved to Soltoguards and Gadgets Ltd, Lagos State as a procurement manager/
Client Relationship officer. In 2017, Mr. Alede proceeded to the Advanced Institute of Security
of Nigeria, University of Lagos and obtained Advanced Diploma in Strategic Security and
Infrastructure Protection Management. In 2023, Mr. Alede moved to the United Kingdom
where he has been working till date and has joined Geega Resources to move the
organization far.`,
  },
  {
    id: 7,
    name: "Miss Ruth Onajomo Segun",
    position: "Director of Media and Publicity",
    image: Ruth,
    achievements: `Miss Segun graduated from the great Madona University, Okija, Anambra State, Nigeria in
2013 with a Bachelor of Art in English Language. She began her professional career in 2014
at Sunset Group of Schools where she became an English/ Literature teacher. She guided and
mentored students with passion in arts and literature. She conducted and supervised exams
and worked extensively with the management of the school in offering the best services to the
students.
In 2017, Ruth was again hired by Python Engineering as an executive assistant to the
Manager. She assisted the manager in carrying out several projects of the company. In 2020,
Ruth left the company to pursue her passion in media. She became a freelance social media
manager and has been contracted by several organizations to manage their social media
handles. She has been a social media marketer for several companies including Avec Foi.
Ruth has joined Geega Resources and thus, shall oversee Geega Resources various social
media platforms.`,
  },
  {
    id: 8,
    name: "Miss Mary Eshiet",
    position: "Director of Human Resources",
    image: Mary,
    achievements: `Mary is a very industrious lady with excellent entrepreneurial skills. She is currently pursuing a
bachelor&#39;s degree in economics at the University of Lagos. Before joining Geega Resources,
Mary had worked as a manager at various organizations. In 2022, Mary was appointed
manager of Ibot Exclusive Event, Lagos State. While working at Ibot, Mary oversaw
preparation and management of the budgets of the company. She supervised all the staff. She
planned and managed events on behalf of the company. She sourced and negotiated with
vendors and suppliers, analyzed the success of events and prepared reports for the
management of the organization.
Aside from the above, Mary has worked closely with many start-up companies, advising them
on human resource management and other factors that can help boost their organization.`,
  },
];

const Director = () => {
  const [selectedDirector, setSelectedDirector] = useState(null);

  const openModal = (director) => {
    setSelectedDirector(director);
  };

  const closeModal = () => {
    setSelectedDirector(null);
  };

  return (
    <div className="directors-page">
      <h1>Board of Directors</h1>
      <div className="directors-grid">
        {directors.map((director) => (
          <div
            key={director.id}
            className="director-card"
            onClick={() => openModal(director)}
          >
            <img
              src={director.image}
              alt={director.name}
              className="director-image"
            />
            <div className="director-name">{director.name}</div>
            <div className="director-position">{director.position}</div>
          </div>
        ))}
      </div>

      {selectedDirector && (
        <DirectorModal director={selectedDirector} closeModal={closeModal} />
      )}
    </div>
  );
};

export default Director;
